








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BaseCheckbox extends Vue {
  @Prop() name!: string
  @Prop() label!: string
  @Prop() checked: boolean

  handleInput ($event: any) {
    this.$emit('input', $event.target.checked)
  }
}
